import { ReactNode } from 'react';
import { Container } from 'roo-ui/components';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { getBookingDetailsPageLink } from 'lib/links';
import { useDetailsBooking } from 'lib/hooks/useDetailsBooking';
import PageHeader from 'components/PageHeader';
import { BonusPointsDisclaimer, CreditVoucherDisclaimer, GlobalDisclaimers } from 'components/Disclaimers';

const CancellationPageLayout = ({ children }: { children: ReactNode }) => {
  const { booking } = useDetailsBooking();
  const detailsPageLink = getBookingDetailsPageLink(booking.id);

  return (
    <>
      <PageHeader
        title="Cancel your booking"
        bookingRef={booking.reference}
        backLinkUrl={detailsPageLink}
        backLinkTitle="Manage your booking"
        onClickBackLink={track.manageBookingReturnLinkTopSelected}
      />
      {children}
      <Container>
        <CreditVoucherDisclaimer.Body />
        <BonusPointsDisclaimer.Body />
        <GlobalDisclaimers />
      </Container>
    </>
  );
};

export default CancellationPageLayout;
